module.exports = __webpack_public_path__ + "media/images/pic/anime/heroes-c270c21ec8c8d8a642cab199f3c3a623.svg";